import { TextField } from "@mui/material";
import { useState, useCallback } from "react";
import { IoMdTrash } from "react-icons/io";
import ConfirmationDialog from "../../../common/confirmationDialog";

export default function CustomField({
  customField,
  handleLocalCustomFieldsChange,
  index,
  handleDelete,
}) {
  const [open, setOpen] = useState(false);

  const handleChange = useCallback(
    (event) => {
      const { name, value } = event.target;
      const newLocalField = { ...customField, [name]: value };
      handleLocalCustomFieldsChange(newLocalField, index);
    },
    [customField, handleLocalCustomFieldsChange, index]
  );

  const handleConfirmDelete = useCallback(async () => {
    handleDelete(index);
    setOpen(false);
  }, [handleDelete, index, setOpen]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <div>
      <ConfirmationDialog
        open={open}
        title={"Confirm"}
        content={"Do you want to delete this customField?"}
        onClose={handleClose}
        onConfirm={handleConfirmDelete}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <TextField
            name="name"
            variant="outlined"
            size="small"
            label="Name"
            fullWidth
            value={customField.name}
            onChange={handleChange}
          />
          <IoMdTrash
            color="red"
            size={30}
            cursor={"pointer"}
            onClick={() => setOpen(true)}
          />
        </div>

        <TextField
          name="value"
          variant="outlined"
          size="small"
          label="Value"
          multiline
          fullWidth
          minRows={2}
          value={customField.value}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}
